<section class="second-opinion-fr" aria-labelledby="second-opinion-international-title">
  <h2 id="second-opinion-international-title">Ask for a second opinion</h2>

  <h3>A quick and easy procedure, right from your home</h3>
  <ul class="second-opinion-fr__list">
    <li>You can submit your application online in just a few clicks, <a [href]="secondOpinionUrl" target="_blank" rel="noopener noreferrer">via this platform</a>.</li>
    <li>On receipt of your complete application, the medical opinion will be sent to you by e-mail <strong>within 7 days</strong>: you will be notified as soon as it is available.</li>
    <li>Once you have received the second opinion, and for the next 14 days, you can ask the doctor for further details or ask additional questions directly on the platform.</li>
  </ul>

  <h3>The process is made easier thanks to…</h3>
  <p>
    <strong>100% English access:</strong> you don't need to speak French to request a second opinion from Gustave Roussy:
    the platform, all exchanges and the medical opinion are all available in English. Your medical file can be sent in
    English or French.
  </p>
  <p>
    <strong>Support from a single point of contact:</strong> you will be in contact with a <strong>case manager</strong>. The case
    manager will work with you to ensure that your file is complete before it is sent to the Gustave Roussy expert who
    will issue the medical opinion, in order to guarantee the fastest possible response. He or she will also coordinate
    exchanges with the expert.
  </p>
  <p>
    Regarding your case complexity, or on recommendation of the case manager, a multidisciplinary team may review your
    medical record. In this case, providing your agreement, a board of specialists will discuss your record before
    giving an opinion. Please note that this review will incur additional costs and additional delay, as 14 days are
    necessary for such multidisciplinary reports.
  </p>
  <p>
    Gustave Roussy also offers <strong>video consultations</strong> to international patients seeking a second medical opinion. This
    remote service allows you to discuss your case directly with our specialists and then receive an expert report.
    Once your medical file has been reviewed and your request accepted, a secure video consultation will be scheduled
    at a time that suits your time zone. This option ensures timely access to our expertise, wherever you are in the world.
  </p>

  <p class="second-opinion-fr__cta">
    <a class="second-opinion-fr__button" [href]="secondOpinionUrl" target="_blank" rel="noopener noreferrer">
      ASK FOR A SECOND OPINION
    </a>
  </p>

  <h3>Please note</h3>
  <p>The price of this personalized and detailed second opinion covers the platform cost and the expert consultation.</p>
  <p>An opinion given on the basis of the information provided does not take the place of a prescription.</p>
  <p>The advice given does not constitute a commitment to treatment at Gustave Roussy.</p>

  <h3>World-renowned expertise</h3>
  <p>
    Leading Cancer Centre in Europe, <strong>Gustave Roussy is ranked #4 world's best oncology hospital according to
    Newsweek magazine</strong> and the first one outside the United States. The institute treats patients with all types of cancer at any
    age and is expert in the treatment of rare and complex tumours. We place innovation at the heart of a human,
    scientific and technological revolution in the fight against cancer.
  </p>
  <p><strong>Discover Gustave Roussy by video:</strong></p>
  <div class="second-opinion-fr__video">
    <iframe
      src="https://www.youtube-nocookie.com/embed/HTF4Mekzkqc"
      title="Gustave Roussy: Europe's leading comprehensive centre"
      loading="lazy"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
      allowfullscreen>
    </iframe>
  </div>

  <h3>Experienced teams at the cutting edge of knowledge</h3>
  <p>
    Our physicians and researchers respond to a continuing challenge: deliver patients the fruits of the most recent
    advances. They devote their energies and their skills to this great challenge: to speed up progress in order to
    expand the limits of knowledge and offer patients continuing improvements in the specificity of their treatment.
  </p>
  <p>
    Gustave Roussy's physicians and researchers include internationally-renowned experts, 15 of them are part of the
    Highly Cited Researchers list in 2023. This list identifies researchers who exert a significant global influence
    in their field of research: a result that reflects the excellence of the research and innovation work carried out
    within the institute.
  </p>
  <p>
    Asking Gustave Roussy for a second opinion means ensuring that the opinion you receive takes into account the
    latest scientific knowledge on cancer diagnosis and treatment, including rare cancers, cutting-edge techniques and
    innovative treatments (clinical trials).
  </p>
  <p>A second opinion may be offered for the following oncology specialties:</p>
  <ul class="second-opinion-fr__specialties">
    <li>Oncogenetics</li>
    <li>Head and neck</li>
    <li>Dermatology</li>
    <li>Digestive</li>
    <li>Gynaecology</li>
    <li>Haematology</li>
    <li>Neurology</li>
    <li>Child and adolescent oncology</li>
    <li>Thorax</li>
    <li>Genitourinary</li>
    <li>Sarcoma</li>
    <li>Senology</li>
  </ul>

  <p class="second-opinion-fr__cta">
    <a class="second-opinion-fr__button" [href]="secondOpinionUrl" target="_blank" rel="noopener noreferrer">
      ASK FOR A SECOND OPINION
    </a>
  </p>
</section>
